<template>
  <div class='m-t-20'>
    <SmallSquare class='m-b-25' content="1.可自定义编辑和启用积分任务，启用后用户可通过完成积分任务赢取积分。
2.首次开启“关注送积分”、“完善个人资料”、“收藏商品”任务，需到“赚积分”页面保存设置才能生效。"/>
       <a-table :pagination='false' :loading='listLoading' bordered rowKey='id'  :columns='columns' :data-source='data'>
         <template v-slot:action="{ record }">
          <a-dropdown>
            <a class="ant-dropdown-link"> 操作
              <DownOutlined />
            </a>
            <template v-slot:overlay>
              <a-menu>
                <a-menu-item>
                  <a @click="edit(record)" href="javascript:;">修改</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click='modifyState(record)' href="javascript:;">禁用</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
  </div>
</template>
<script>
import { reactive, ref,toRefs ,inject,createVNode,h} from 'vue';
import { DownOutlined,ExclamationCircleOutlined} from "@ant-design/icons-vue";
import { getIntegralList } from "@/api/assets";
import { iscode } from '@/utils/app';
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10
};
export default {
  components:{DownOutlined},
  setup(){
    const state=reactive({
      listLoading:false,
      total:0
    })
    const search=ref({...defSearch})
       // 列表数据和列头配置
    let data = ref();
    let columns = [
      {
        title: "任务名称",
        dataIndex: "name",
        key: "name",
      },
        {
        title: "任务描述",
        dataIndex: "describe",
        key: "describe",
      },
      {
        title: "奖励",
        dataIndex: "reward",
        key: "reward",
      },
        {
        title: "奖励频次",
        dataIndex: "reward_num",
        key: "reward_num",
      },
      {
        title: "状态",
        dataIndex: "status",
        // customRender:({record})=>{
        //     return  record.status==0?'禁用':'启用'
        // }
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ]
    const $Modal = inject('$Modal')
   const initData = async (values) => {
      state.listLoading = true;
        let res = await getIntegralList(values).then(res=>res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } 
    };
    initData(search.value)
        // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const modifyState = () =>{
      $Modal.confirm({
        centered:true,
        width:500,
        title: '积分任务禁用',
        icon: createVNode(ExclamationCircleOutlined),
        content: h('div', {}, [
          h('p',{className:'m-b-15'}, '禁用后用户将无法通过做该任务获取积分确定要继续吗？')
        ]),
        onOk() {},
        onCancel() {},
      });
    }
    const edit=()=>{

    }
    return{
       ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      modifyState,
      edit
    }
  }
}
</script>